export default "__VITE_ASSET__Bf2Xn8Ug__"